import { getFeatureConfig } from '@luna/feature-config';

import { formatOptionalDate } from '../dates/formatOptionalDate';

export const RANGE_FORMAT_DELIMITER = '-';

export const getFormattedRange = (fromValue?: string, toValue?: string): string => {
    if (fromValue && toValue) {
        return `${fromValue} ${RANGE_FORMAT_DELIMITER} ${toValue}`;
    }

    return toValue || fromValue || '';
};

export const getUnformattedRange = (
    formattedRange: string,
): [string | undefined, string | undefined] => {
    const [fromValue, toValue] = formattedRange
        .split(RANGE_FORMAT_DELIMITER)
        .map((value) => value.trim());

    return [fromValue || undefined, toValue || undefined];
};

export const getFormattedDateRange = (startDate?: string, endDate?: string): string => {
    const format = getFeatureConfig((config) => config.base.defaultDateFormat);
    const start = formatOptionalDate(startDate, format);
    const end = formatOptionalDate(endDate, format);
    return getFormattedRange(start, end);
};
